import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';

import Moment from 'moment';

import { Table, Select, Input, Button, Space, notification } from 'antd';
import { InfoCircleOutlined, UploadOutlined } from '@ant-design/icons';
// import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';

import * as storeActions from './store/actions/expiring_orders';

import Loader from '../../common/PageElements/Loader';
import PageHeader from '../../common/PageElements/PageHeader'

class ExpiringOrdersList extends Component {
   state = {
      loader: true,
      itemList: [],
      daysList: [5, 15, 30, 60],
      searchText: '',
      searchedColumn: '',
      componentLanguage: this.props.authState.defaultLanguage,
      searchDays: 15
   };

   getList = (searchDays) => {
      // asyncronous calls
      storeActions.getList(searchDays)
         .then(response => {
            console.log(response);
            try {
               this.setState({ itemList: response.data, searchDays: searchDays, loader: false });
            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   componentDidMount() {
      this.getList(this.state.searchDays);
   }

   componentDidUpdate(prevProps, prevState) {
      // debugger;
      if (this.state.searchDays !== prevState.searchDays) {
         console.log('Component update');
         this.setState({ loader: true });
         this.getList(this.state.searchDays);
      }
   }

   confirmHandler = (onConfirm, itemId) => {
      switch (onConfirm) {
         // case 'deleteItem':
         //    if (itemId) {
         //       this.deleteItemHandler(itemId);
         //    }
         //    break;
         default:
            return;
      }
   }

   getColumnSearchProps = (dataIndex, title) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  this.searchInput = node;
               }}
               placeholder={`Cerca ${title}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
               >
                  Search
            </Button>
               <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
            </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase().trim()) : '',
      onFilterDropdownVisibleChange: visible => {
         if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
         }
      },
      render: (text, record) =>
         this.state.searchedColumn === dataIndex ? (
            <Button className="link" onClick={() => this.props.history.push('/expiring_orders/details/' + record.id)}>
               <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={[this.state.searchText.trim()]}
                  autoEscape
                  textToHighlight={record[dataIndex] ? record[dataIndex] : ''}
               />
            </Button>
         ) : (
               <Button className="link" onClick={() => this.props.history.push('/expiring_orders/details/' + record.id)}>
                  {record[dataIndex].toString()}
               </Button>
            ),
   });
   handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({
         searchText: selectedKeys[0],
         searchedColumn: dataIndex,
      });
   };
   handleReset = clearFilters => {
      clearFilters();
      this.setState({ searchText: '' });
   };

   setSearchDays = (day) => {
      this.setState({ searchDays: day });
   }

   render() {
      if (!this.props.authState.userData.languages) return '';
      console.log(this.state);
      const { Option } = Select;

      const table_columns = [
         {
            title: 'Ordine',
            width: 150,
            key: 'purchase_order_number',
            fixed: 'left',
            sorter: (a, b) => a.purchase_order_number.localeCompare(b.purchase_order_number),
            ...this.getColumnSearchProps('purchase_order_number', 'ordine'),
         },
         {
            title: 'Fornitore',
            width: 150,
            key: 'vendor',
            fixed: 'left',
            render: (record) => (
               record.vendor
            ),
            sorter: (a, b) => a.vendor.localeCompare(b.vendor),
         },
         {
            title: 'Ordinato il',
            width: 120,
            key: 'order_date',
            fixed: 'left',
            render: (record) => (
               Moment(record.order_date).format('L')
            ),
            sorter: (a, b) => a.order_date.localeCompare(b.order_date),
         },
         {
            title: 'Giorno',
            width: 100,
            key: 'order_day',
            dataIndex: 'order_day',
            fixed: 'left',
            render: (text, record) => {
               return {
                  props: {
                     className: record.order_day === 'Monday' ? "classNameOfCell" : '',
                  },
                  children: text,
               };
            },
            sorter: (a, b) => a.order_day.localeCompare(b.order_day),
         },
         {
            title: 'Magazzino',
            width: 200,
            key: 'shipment_address',
            fixed: 'left',
            render: (record) => (
               record.shipment_address
            ),
            sorter: (a, b) => a.shipment_address.localeCompare(b.shipment_address),
            ellipsis: true,
         },
         {
            title: 'Inizio finestra',
            width: 150,
            key: 'shipment_window_start',
            fixed: 'left',
            render: (record) => (
               Moment(record.shipment_window_start).format('L')
            ),
            sorter: (a, b) => a.shipment_window_start.localeCompare(b.shipment_window_start),
         },
         {
            title: 'Fine finestra',
            width: 150,
            key: 'shipment_window_end',
            fixed: 'left',
            render: (record) => (
               Moment(record.shipment_window_end).format('L')
            ),
            sorter: (a, b) => a.shipment_window_end.localeCompare(b.shipment_window_end),
         },
         {
            title: 'Quantità',
            width: 150,
            dataIndex: 'items_total',
            key: 'items_total',
            fixed: 'left',
            sorter: (a, b) => a.items_total - b.items_total,
         },
         {
            title: 'Articoli importati',
            width: 150,
            dataIndex: 'order_lines_count',
            key: 'order_lines_count',
            fixed: 'left',
            sorter: (a, b) => a.order_lines_count - b.order_lines_count,
         },
         {
            title: 'Articoli mancanti',
            width: 150,
            dataIndex: 'order_lines_not_completed_count',
            key: 'order_lines_not_completed_count',
            fixed: 'left',
            filters: [
               {
                  text: 'Mostra solo ordini con articoli mancanti',
                  value: false,
               }
            ],
            filterMultiple: false,
            onFilter: (value, record) => {
               if (value) {
                  return record.order_lines_not_completed_count
               }
               else {
                  return record.order_lines_not_completed_count > 0
               }
            },
            sorter: (a, b) => a.order_lines_not_completed_count - b.order_lines_not_completed_count,
         },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  <Button className="link" onClick={() => this.props.history.push('/expiring_orders/details/' + record.id)} title={languageManager.getMessage(this.props.commonState, 'common.edit')}>
                     <i className="far fa-edit"></i>
                  </Button>
               </Space>),
         },
      ];
      const tableLayout = {
         bordered: true,
         ellipsis: true,
         size: "small",
         pagination: { pageSize: 50 }
      }

      const daysSelect = (
         <Select
            showSearch
            size="large"
            placeholder="Seleziona i giorni"
            defaultValue={this.state.searchDays}
            optionFilterProp="children"
            onChange={this.setSearchDays}
         //  onFocus={onFocus}
         //  onBlur={onBlur}
         //  onSearch={onSearch}
         //  filterOption={(input, option) =>
         //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
         //  }
         >
            {
               this.state.daysList.map((day) => {
                  return <Option key={day} value={day}>{day}</Option>
               })
            }
         </Select>
      );

      const pageContent = (
         <div className="card">
            <div className="card-header">
               <div className="align-items-center row">
                  <div className="col-sm-6">
                     {languageManager.getMessage(this.props.commonState, 'component.expiring_orders.title')}
                  </div>

                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">
                        <Space>
                           <Button
                              size='large'
                              type='primary'
                              icon={<UploadOutlined />}
                              onClick={() => this.props.history.push('/expiring_orders/import/')}
                           >
                              Importa ordini da CSV
                           </Button>
                           <Select
                              showSearch
                              size="large"
                              className="width-70px-I"
                              placeholder="Seleziona la lingua"
                              defaultValue={this.state.componentLanguage}
                              optionFilterProp="children"
                              onChange={this.setDefaultLanguageHandler}
                           //  onFocus={onFocus}
                           //  onBlur={onBlur}
                           //  onSearch={onSearch}
                           //  filterOption={(input, option) =>
                           //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                           //  }
                           >
                              {
                                 this.props.authState.userData.languages.map((lang) => {
                                    return <Option key={lang.value} value={lang.value}>{lang.label}</Option>
                                 })
                              }
                           </Select>
                        </Space>
                     </div>
                  </div>
               </div>
               <div className="card-body">
                  {daysSelect}
                  {this.state.loader ? <Loader /> : <Table
                     {...tableLayout}
                     columns={table_columns}
                     dataSource={this.state.itemList}
                     rowClassName={(record, index) =>
                        record.order_day === 'Monday' ? 'table-row-light' : 'table-row-dark'
                     }
                  />}
               </div>
            </div>
         </div>
      );

      const helpButton = {
         title: "Aiuto"
      }

      const buttons = [];
      buttons.push(helpButton);

      // const editForm = (
      //    <div className="card">
      //       <div className="card-header">Tasse</div>
      //       <div className="card-body">
      //          <TaxRatesForm action={this.state.action} itemData={this.state.itemData} closeAction={() => this.closeActionHandler()} />
      //       </div>
      //    </div>
      // );

      return (
         <div className="container-fluid">
            <PageHeader
               title={languageManager.getMessage(this.props.commonState, 'component.expiring_orders.title')}
               buttons={buttons}
            />
            <div className="row">
               <div className="col">
                  {pageContent}
               </div>
            </div>
         </div>
      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState,
   };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(ExpiringOrdersList);